var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-list-view',{attrs:{"title":"Сводные отчеты","dataSource":_vm.dataSource,"headers":_vm.headers,"loading":_vm.loading,"pageEditName":"ConsolidatedReportEdit"},on:{"onRefresh":_vm.init,"onDelete":_vm.del}})
}
var staticRenderFns = []

export { render, staticRenderFns }